// extracted by mini-css-extract-plugin
export var button = "add-shopping-list-modal-module--button--f3882";
export var errorMessage = "add-shopping-list-modal-module--error-message--3bc7c";
export var formAdd = "add-shopping-list-modal-module--form-add--66063";
export var formSelect = "add-shopping-list-modal-module--form-select--b6574";
export var input = "add-shopping-list-modal-module--input--b5d0d";
export var modal = "add-shopping-list-modal-module--modal--cba63";
export var separator = "add-shopping-list-modal-module--separator--f7853";